export default {
  init() {
    window.addEventListener("load", function(){
      window.cookieconsent.initialise({
        "palette": {
          "popup": {
            "background": "#fff",
            "text": "#0071bd",
          },
          "button": {
            "background": "#0071bd",
            "text": "#fff",
          },
        },
        "content": {
          "href": "/privacy-policy",
        },
      })
    });

    function headerAnimation() {
      var fixedHeader = $('.fixed-header');
      if ($(window).scrollTop() > $('#masthead').offset().top + $('#masthead').height() + 20) {
        fixedHeader.addClass('show');
      } else {
        fixedHeader.removeClass('show');
      }
    }

    headerAnimation();

    $(window).on('scroll', function() {
      headerAnimation();
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    if($('.tagcloud select').length) {
      //Set tag cloud dropdown to autoload the page
      var tagCloudDropdown = $(".tagcloud select");
      $(tagCloudDropdown).on('change', function() {
        window.open(this.options[this.selectedIndex].value, "_self");
      });
    }
    
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js